import { randomUUID } from 'node:crypto';
import type { WixConfig } from '@wix/cli-app-definitions';
import { saveWixConfig } from '../../../files/wix.config.js';

export async function generateSidebarCategory(
  projectFolder: string,
  config: WixConfig,
  categoryLabel: string
) {
  const initialCategories = config.dashboard?.sidebar?.categories ?? [];

  return saveWixConfig(projectFolder, {
    ...config,
    dashboard: {
      ...config.dashboard,
      sidebar: {
        ...config.dashboard?.sidebar,
        categories: initialCategories.concat({
          id: randomUUID(),
          label: categoryLabel,
        }),
      },
    },
  });
}
